import { getEmFields } from "../../../libs/em/fields";

export function getEmField(type, name) {
  const emFields = getEmFields();
  for (var idx = 0; idx < emFields?.[type]?.length; idx++) {
    const entry = emFields[type][idx];
    if (entry?.id === name) {
      return entry;
    }
  }
}

export function calculateLevels(scorecard) {
  const complexityLevel = scorecard?.complexity
    ? calculateSingleLevel(scorecard?.complexity, "complexity")
    : 1;

  const dataLevel = scorecard?.data
    ? calculateSingleLevel(scorecard?.data, "data")
    : 1;
  const riskLevel = scorecard?.risk
    ? calculateSingleLevel(scorecard?.risk, "risk")
    : 1;
  const timeLevel = scorecard?.time
    ? calculateSingleLevel(scorecard?.time, "time")
    : 1;

  // console.log("==calculating levels==");
  // console.log(scorecard);

  const noteLevel = generateNoteLevel(
    complexityLevel,
    dataLevel,
    riskLevel,
    timeLevel
  );

  return {
    complexity: complexityLevel,
    data: dataLevel,
    risk: riskLevel,
    time: timeLevel,
    note: noteLevel,
  };
}

export function calculateSingleLevel(item, type) {
  if (type === "complexity") {
    const counts = {};


    item?.problems.forEach((problem) => {
      counts[problem.type] = (counts[problem.type] || 0) + 1;
    });



    if (counts["LIFE_THREAT"] >= 1 || counts["CHRONIC_SEVERE"] >= 1) {
      return 5;
    }

    if (
      counts["CHRONIC_PROGRESSION"] >= 1 ||
      counts["CHRONIC_STABLE"] >= 2 ||
      counts["UNDIAGNOSED"] >= 1 ||
      counts["ACUTE_SYSTEMIC"] >= 1 ||
      counts["ACUTE_COMPLICATED"] >= 1
    ) {
      return 4;
    }

    if (
      counts["MINOR"] >= 2 ||
      counts["CHRONIC_STABLE"] === 1 ||
      counts["ACUTE_UNCOMPLICATED"] >= 1
    ) {
      return 3;
    }

    if (counts["MINOR"] >= 1) {
      return 2;
    }

    return 1;
  }

  if (type === "data") {
    const counts = {
      REVIEW_NOTE: 0,
      REVIEW_RESULT: 0,
      ORDER_TEST: 0,
      HISTORIAN: 0,
      EXTERNAL_DISCUSSION: 0,
      EXTERNAL_INTERPRETATION: 0,
    };
    item?.items.forEach((entry) => {
      counts[entry.type] = (counts[entry.type] || 0) + 1;
    });

    // console.log("==counts==", counts);


    var count_categories =
      !!counts["EXTERNAL_DISCUSSION"] +
      !!counts["EXTERNAL_INTERPRETATION"] +
      (counts["REVIEW_NOTE"] +
        counts["REVIEW_RESULT"] +
        counts["ORDER_TEST"] +
        counts["HISTORIAN"] >=
        3);

    // console.log("==categories==", count_categories);
    if (count_categories >= 2) {
      return 5;
    }
    if (count_categories >= 1) {
      return 4;
    }
    if (
      counts["REVIEW_NOTE"] + counts["REVIEW_RESULT"] + counts["ORDER_TEST"] >=
        2 ||
      !!counts["HISTORIAN"]
    ) {
      return 3;
    }
    return 2;
  }

  if (type === "risk") {
    const riskLevels = {
      MINIMAL: 2,
      LOW: 3,
      MODERATE: 4,
      HIGH: 5,
    };

    return riskLevels[item.type] || 1;
  }

  if (type === "time") {
    const time = parseInt(item.visit_duration_sec, 10);
    const increment =
      item.visit_type === "NEW"
        ? 15
        : item.visit_type === "EXISTING"
        ? 10
        : null;

    if (!increment) {
      console.error(
        "Error: Invalid patient type in time-based E&M calculation"
      );
      return;
    }

    const level = Math.min(Math.floor(time / increment) + 1, 5);
    return level;
  }

  console.log("Error: Invalid E&M column");

  return null;
}

export function generateNoteLevel(complexity, data, risk, time) {
  const scores = [complexity, data, risk];
  scores.sort((a, b) => a - b);
  return scores[1];
}
